import { render, staticRenderFns } from "./FormFcontinueedit.vue?vue&type=template&id=04bed522&"
import script from "./FormFcontinueedit.vue?vue&type=script&lang=js&"
export * from "./FormFcontinueedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports